export default "__VITE_ASSET__CTR81wNU__"